define('src/plugins/jquery.extension',[
    // Libs
    'jquery',
], function($) {

    $.fn.extend({
        toggleDisabled: function(state) {
            return this.each(function() {
                this.disabled = state === undefined ? !this.disabled : Boolean(state);
            });
        },

        /**
         * Removes all classes matching the prefix, matching like a
         * "prefix-*" selector.
         *
         *     $('<div class="column prefix-sm"></div>')
         *         .removeClassPrefix("prefix-");
         *     => <div class="column"></div>
         *
         * @param  {string} prefix - to match against.
         * @return {jQuery} this to chain calls.
         */
        removeClassPrefix: function(prefix) {
            var regex = new RegExp("(^|\\s)" + prefix + "\\S+", 'g');
            this.each(function() {
                var c = this.getAttribute('class');
                if (c) this.setAttribute('class', c.replace(regex, ''));
            });
            return this;
        },
    });

});

